import dayjs from "dayjs";

function csvEscape(val) {
  if (val === null || val === undefined) return "";
  const str = String(val);
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
}

function buildUsersCsv(users) {
  const headers = ["First Name", "Last Name", "Email", "Account Name", "Last Login", "Status"];
  const rows = users.map((u) => [
    csvEscape(u.first_name),
    csvEscape(u.lastname),
    csvEscape(u.email),
    csvEscape(u.account?.company_name || ""),
    csvEscape(
      u.last_connection
        ? dayjs(u.last_connection).format("MM-DD-YYYY HH:mm")
        : "Sin ingreso"
    ),
    csvEscape(u.is_active ? "Active" : "Inactive"),
  ].join(","));
  return [headers.join(","), ...rows].join("\n");
}

export default function downloadUsersCsv(users) {
  const csv = buildUsersCsv(users);
  const filename = `Users_Export_${dayjs().format("YYYY-MM-DD")}.csv`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
